import type { Lead } from '../types'

export const leads: Lead[] = [
  {
    id: 'l-1',
    name: 'Marcus Whitfield',
    phone: '(415) 555-0182',
    email: 'm.whitfield@gmail.com',
    leadType: 'Refinance',
    attributes: {
      currentBalance: '$486,000',
      currentRate: '6.875%',
      estimatedValue: '$720,000',
      goal: 'Lower monthly payment',
      creditBand: '740–759',
    },
    sourceId: 'lendingtree',
    ownerId: 'o-sarah',
    status: 'Attempting Contact',
    ageMinutes: 210,
    callsToday: 2,
    priorityRuleId: 'p-lt-01',
    lastContactMinutes: 74,
    contacted: false,
    speedToLeadSeconds: 168,
    activities: [
      {
        id: 'a-1-1',
        type: 'task',
        title: 'Callback promised to borrower',
        detail: 'Borrower asked for a call back after 2pm regarding rate lock options.',
        dueInMinutes: -46,
      },
      {
        id: 'a-1-2',
        type: 'call',
        title: 'Outbound call — no answer',
        detail: 'Rang 6 times, left no voicemail.',
        minutesAgo: 74,
        outcome: 'No Answer',
      },
      {
        id: 'a-1-3',
        type: 'sms',
        title: 'SMS sent',
        detail: '“Hi Marcus — tried you just now about your rate quote. Good time to talk?”',
        minutesAgo: 72,
      },
      {
        id: 'a-1-4',
        type: 'call',
        title: 'Outbound call — voicemail left',
        minutesAgo: 186,
        outcome: 'Voicemail',
      },
      {
        id: 'a-1-5',
        type: 'email',
        title: 'Email sent — New Lead Introduction',
        minutesAgo: 205,
      },
      { id: 'a-1-6', type: 'note', title: 'Lead created from LendingTree', minutesAgo: 210 },
    ],
  },
  {
    id: 'l-2',
    name: 'Priya Raman',
    phone: '(408) 555-0147',
    email: 'priya.raman@outlook.com',
    leadType: 'Refinance',
    attributes: {
      currentBalance: '$612,000',
      currentRate: '7.125%',
      estimatedValue: '$905,000',
      goal: 'Payoff estimate requested',
      creditBand: '760+',
    },
    sourceId: 'website',
    ownerId: 'o-sarah',
    status: 'New',
    ageMinutes: 4,
    callsToday: 0,
    priorityRuleId: 'p-hot',
    contacted: false,
    activities: [
      {
        id: 'a-2-1',
        type: 'note',
        title: 'Lead created from Website — refinance inquiry',
        detail: 'Requested payoff estimate on a $612,000 balance.',
        minutesAgo: 4,
      },
    ],
  },
  {
    id: 'l-3',
    name: 'Dana Okafor',
    phone: '(510) 555-0119',
    email: 'dokafor@fastmail.com',
    leadType: 'Purchase',
    attributes: {
      targetPrice: '$845,000',
      downPayment: '10% ($84,500)',
      timeline: '30–60 days',
      preApproval: 'Not started',
      creditBand: '720–739',
    },
    sourceId: 'zillow',
    ownerId: 'o-sarah',
    status: 'Contacted',
    ageMinutes: 1320,
    callsToday: 1,
    priorityRuleId: 'p-callback',
    lastContactMinutes: 320,
    contacted: true,
    speedToLeadSeconds: 96,
    activities: [
      {
        id: 'a-3-1',
        type: 'event',
        title: 'Pre-approval consultation',
        detail: 'Scheduled 30-minute Zoom review.',
        dueInMinutes: -125,
      },
      { id: 'a-3-2', type: 'call', title: 'Outbound call — connected', minutesAgo: 320, outcome: 'Connected' },
      { id: 'a-3-3', type: 'note', title: 'Shopping in Alameda, 10% down target', minutesAgo: 318 },
      { id: 'a-3-4', type: 'email', title: 'Email sent — Document Checklist', minutesAgo: 300 },
    ],
  },
  {
    id: 'l-4',
    name: 'Tyler Brennan',
    phone: '(650) 555-0173',
    email: 'tbrennan88@gmail.com',
    leadType: 'Purchase',
    attributes: {
      targetPrice: '$615,000',
      downPayment: '5% ($30,750)',
      timeline: '60–90 days',
      preApproval: 'Not started',
      creditBand: '680–699',
    },
    sourceId: 'lendingtree',
    ownerId: 'o-sarah',
    status: 'Attempting Contact',
    ageMinutes: 2760,
    callsToday: 1,
    priorityRuleId: 'p-lt-23',
    lastContactMinutes: 460,
    contacted: false,
    speedToLeadSeconds: 412,
    activities: [
      { id: 'a-4-1', type: 'call', title: 'Outbound call — no answer', minutesAgo: 460, outcome: 'No Answer' },
      { id: 'a-4-2', type: 'sms', title: 'SMS sent', minutesAgo: 455 },
      { id: 'a-4-3', type: 'call', title: 'Outbound call — no answer', minutesAgo: 1500, outcome: 'No Answer' },
    ],
  },
  {
    id: 'l-5',
    name: 'Alicia Moreno',
    phone: '(925) 555-0106',
    email: 'alicia.moreno@yahoo.com',
    leadType: 'Purchase',
    attributes: {
      targetPrice: '$520,000',
      downPayment: '20% ($104,000)',
      timeline: 'Under 30 days',
      preApproval: 'Shopping with 2 lenders',
      creditBand: '760+',
    },
    sourceId: 'zillow',
    ownerId: 'o-sarah',
    status: 'New',
    ageMinutes: 640,
    callsToday: 0,
    priorityRuleId: 'p-zl-01',
    contacted: false,
    speedToLeadSeconds: 520,
    activities: [
      {
        id: 'a-5-1',
        type: 'task',
        title: 'First contact attempt required',
        dueInMinutes: -20,
      },
      { id: 'a-5-2', type: 'note', title: 'Lead created from Zillow', minutesAgo: 640 },
    ],
  },
  {
    id: 'l-6',
    name: 'Jonah Feldman',
    phone: '(707) 555-0155',
    email: 'jonah.feldman@protonmail.com',
    leadType: 'Cash-Out Refinance',
    attributes: {
      currentBalance: '$398,000',
      estimatedValue: '$690,000',
      cashOutTarget: '$85,000',
      currentRate: '5.5%',
      creditBand: '700–719',
    },
    sourceId: 'website',
    ownerId: 'o-sarah',
    status: 'Attempting Contact',
    ageMinutes: 3200,
    callsToday: 1,
    priorityRuleId: 'p-followup',
    lastContactMinutes: 900,
    contacted: true,
    speedToLeadSeconds: 240,
    activities: [
      { id: 'a-6-1', type: 'task', title: 'Send updated rate sheet', dueInMinutes: 180 },
      { id: 'a-6-2', type: 'call', title: 'Outbound call — connected', minutesAgo: 900, outcome: 'Connected' },
      { id: 'a-6-3', type: 'email', title: 'Email sent — Rate Update', minutesAgo: 880 },
    ],
  },
  {
    id: 'l-7',
    name: 'Rebecca Lin',
    phone: '(628) 555-0134',
    email: 'rlin@workmail.com',
    leadType: 'Purchase',
    attributes: {
      targetPrice: '$1,150,000',
      downPayment: '25% ($287,500)',
      timeline: '90+ days',
      preApproval: 'Pre-qualified',
      creditBand: '760+',
    },
    sourceId: 'realtor',
    ownerId: 'o-sarah',
    status: 'Nurture',
    ageMinutes: 7200,
    callsToday: 0,
    priorityRuleId: 'p-followup',
    lastContactMinutes: 2880,
    contacted: true,
    speedToLeadSeconds: 610,
    activities: [
      { id: 'a-7-1', type: 'call', title: 'Outbound call — connected', minutesAgo: 2880, outcome: 'Connected' },
      { id: 'a-7-2', type: 'note', title: 'Pre-qualified, waiting on listing inventory', minutesAgo: 2875 },
    ],
  },
  {
    id: 'l-8',
    name: 'Grant Sullivan',
    phone: '(415) 555-0198',
    email: 'g.sullivan@icloud.com',
    leadType: 'Cash-Out Refinance',
    attributes: {
      currentBalance: '$265,000',
      estimatedValue: '$540,000',
      cashOutTarget: '$60,000',
      currentRate: '4.25%',
      creditBand: '660–679',
    },
    sourceId: 'directmail',
    ownerId: 'o-sarah',
    status: 'Attempting Contact',
    ageMinutes: 9800,
    callsToday: 0,
    priorityRuleId: 'p-aged',
    lastContactMinutes: 4300,
    contacted: false,
    speedToLeadSeconds: 1420,
    activities: [
      { id: 'a-8-1', type: 'call', title: 'Outbound call — no answer', minutesAgo: 4300, outcome: 'No Answer' },
      { id: 'a-8-2', type: 'email', title: 'Email sent — Missed Call Follow-Up', minutesAgo: 4290 },
    ],
  },
  {
    id: 'l-9',
    name: 'Nia Patterson',
    phone: '(510) 555-0164',
    email: 'nia.patterson@gmail.com',
    leadType: 'Refinance',
    attributes: {
      currentBalance: '$342,000',
      currentRate: '7.5%',
      estimatedValue: '$465,000',
      goal: 'Drop mortgage insurance',
      creditBand: '720–739',
    },
    sourceId: 'lendingtree',
    ownerId: 'o-sarah',
    status: 'New',
    ageMinutes: 820,
    callsToday: 1,
    priorityRuleId: 'p-lt-01',
    lastContactMinutes: 200,
    contacted: false,
    speedToLeadSeconds: 300,
    activities: [
      { id: 'a-9-1', type: 'call', title: 'Outbound call — no answer', minutesAgo: 200, outcome: 'No Answer' },
      { id: 'a-9-2', type: 'note', title: 'Lead created from LendingTree', minutesAgo: 820 },
    ],
  },
  {
    id: 'l-10',
    name: 'Victor Alvarez',
    phone: '(669) 555-0128',
    email: 'valvarez@gmail.com',
    leadType: 'Purchase',
    attributes: {
      targetPrice: '$430,000',
      downPayment: '3.5% ($15,050)',
      timeline: '60–90 days',
      preApproval: 'Not started',
      creditBand: '640–659',
    },
    sourceId: 'zillow',
    ownerId: 'o-sarah',
    status: 'Attempting Contact',
    ageMinutes: 5100,
    callsToday: 0,
    priorityRuleId: 'p-aged',
    lastContactMinutes: 1500,
    contacted: false,
    speedToLeadSeconds: 745,
    activities: [
      { id: 'a-10-1', type: 'sms', title: 'SMS sent', minutesAgo: 1500 },
      { id: 'a-10-2', type: 'call', title: 'Outbound call — voicemail left', minutesAgo: 1520, outcome: 'Voicemail' },
    ],
  },
  {
    id: 'l-11',
    name: 'Hannah Weiss',
    phone: '(408) 555-0111',
    email: 'hannah.weiss@gmail.com',
    leadType: 'Purchase',
    attributes: {
      targetPrice: '$725,000',
      downPayment: '15% ($108,750)',
      timeline: 'Under 30 days',
      preApproval: 'Needs letter this week',
      creditBand: '740–759',
    },
    sourceId: 'website',
    ownerId: 'o-sarah',
    status: 'New',
    ageMinutes: 150,
    callsToday: 1,
    priorityRuleId: 'p-followup',
    lastContactMinutes: 60,
    contacted: false,
    speedToLeadSeconds: 210,
    activities: [
      { id: 'a-11-1', type: 'call', title: 'Outbound call — no answer', minutesAgo: 60, outcome: 'No Answer' },
      { id: 'a-11-2', type: 'note', title: 'Lead created from Website', minutesAgo: 150 },
    ],
  },
  {
    id: 'l-12',
    name: 'Owen Castellanos',
    phone: '(831) 555-0177',
    email: 'owen.cast@gmail.com',
    leadType: 'Refinance',
    attributes: {
      currentBalance: '$289,000',
      currentRate: '3.1%',
      estimatedValue: '$610,000',
      goal: 'Revisit if rates drop',
      creditBand: '760+',
    },
    sourceId: 'directmail',
    ownerId: 'o-sarah',
    status: 'Nurture',
    ageMinutes: 14400,
    callsToday: 0,
    priorityRuleId: 'p-aged',
    lastContactMinutes: 7200,
    contacted: true,
    speedToLeadSeconds: 2100,
    activities: [
      { id: 'a-12-1', type: 'call', title: 'Outbound call — connected', minutesAgo: 7200, outcome: 'Connected' },
      { id: 'a-12-2', type: 'note', title: 'Revisit in 60 days, current rate 3.1%', minutesAgo: 7190 },
    ],
  },
  {
    id: 'l-13',
    name: 'Sofia Delgado',
    phone: '(925) 555-0190',
    email: 'sofia.delgado@gmail.com',
    leadType: 'Purchase',
    attributes: {
      targetPrice: '$560,000',
      downPayment: '10% ($56,000)',
      timeline: '30–60 days',
      preApproval: 'Not started',
      creditBand: '700–719',
    },
    sourceId: 'realtor',
    ownerId: 'o-marcus',
    status: 'Attempting Contact',
    ageMinutes: 2100,
    callsToday: 1,
    priorityRuleId: 'p-callback',
    lastContactMinutes: 400,
    contacted: false,
    speedToLeadSeconds: 880,
    activities: [
      { id: 'a-13-1', type: 'task', title: 'Return borrower call', dueInMinutes: -200 },
      { id: 'a-13-2', type: 'call', title: 'Inbound call — missed', minutesAgo: 400 },
    ],
  },
  {
    id: 'l-14',
    name: 'Elliot Nakamura',
    phone: '(650) 555-0122',
    email: 'e.nakamura@gmail.com',
    leadType: 'Refinance',
    attributes: {
      currentBalance: '$512,000',
      currentRate: '6.99%',
      estimatedValue: '$680,000',
      goal: 'Consolidate debt',
      creditBand: '700–719',
    },
    sourceId: 'lendingtree',
    ownerId: 'o-dev',
    status: 'New',
    ageMinutes: 320,
    callsToday: 0,
    priorityRuleId: 'p-lt-01',
    contacted: false,
    speedToLeadSeconds: 1900,
    activities: [
      { id: 'a-14-1', type: 'note', title: 'Lead created from LendingTree', minutesAgo: 320 },
    ],
  },
]

/** Leads that arrive live while the LO is working the queue. */
export const incomingLeads: Lead[] = [
  {
    id: 'l-live-1',
    name: 'Camille Foster',
    phone: '(415) 555-0210',
    email: 'camille.foster@gmail.com',
    leadType: 'Purchase',
    attributes: {
      targetPrice: '$495,000',
      downPayment: '5% ($24,750)',
      timeline: 'Under 30 days',
      preApproval: 'Not started',
      creditBand: '720–739',
    },
    sourceId: 'lendingtree',
    ownerId: 'o-sarah',
    status: 'New',
    ageMinutes: 1,
    callsToday: 0,
    priorityRuleId: 'p-hot',
    contacted: false,
    activities: [
      { id: 'a-live-1', type: 'note', title: 'Lead created from LendingTree', minutesAgo: 1 },
    ],
  },
  {
    id: 'l-live-2',
    name: 'Andre Boucher',
    phone: '(628) 555-0245',
    email: 'aboucher@gmail.com',
    leadType: 'Purchase',
    attributes: {
      targetPrice: '$880,000',
      downPayment: '20% ($176,000)',
      timeline: '30–60 days',
      preApproval: 'Pre-qualified elsewhere',
      creditBand: '760+',
    },
    sourceId: 'website',
    ownerId: 'o-sarah',
    status: 'New',
    ageMinutes: 1,
    callsToday: 0,
    priorityRuleId: 'p-hot',
    contacted: false,
    activities: [
      { id: 'a-live-2', type: 'note', title: 'Lead created from Website — purchase inquiry', minutesAgo: 1 },
    ],
  },
]
